import { getRequest } from 'config/Axios/baseConfig';
import { BootleByRoomResponse } from 'screens/CalculationsScreen/components/BottleByRoomCalculationTable/bottlebyroom.types';

export const bottleByRoomCalculationsServices = {
  getBottleByRoom: (date: string): Promise<BootleByRoomResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const targetDate = date || new Date().toISOString();

        const { data } = await getRequest<BootleByRoomResponse>(
          `pps/calculations/bottles-by-rooms/${targetDate}`
        );

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
